export const normalizeEmail = (value: string) => value.toLowerCase().trim();
